"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Icon = _ref => {
  let {
    className,
    name,
    containerSize,
    size,
    light,
    dark,
    color,
    inverted,
    iconText,
    iconTextFlex,
    useIconWrapper
  } = _ref;
  let iconColor = color;
  let lightDark = null;
  if (light) {
    lightDark = '-light';
  }
  if (dark) {
    lightDark = '-dark';
  }
  if (inverted) {
    iconColor = 'white';
  }
  const containerClassNames = (0, _classnames.default)({
    [`is-${containerSize}`]: containerSize
  });
  const iconClassNames = (0, _classnames.default)({
    [`has-text-${iconColor}${lightDark}`]: iconColor && lightDark,
    [`has-text-${iconColor}`]: iconColor && !lightDark,
    [`is-size-${size}`]: size
  });
  const iconTextWrapperClassNames = (0, _classnames.default)({
    [`has-text-${iconColor}${lightDark}`]: iconColor && lightDark,
    [`has-text-${iconColor}`]: iconColor && !lightDark
  });
  const iconTextClassNames = (0, _classnames.default)({
    [`is-size-${size + 1}`]: size
  });
  const IconToRender = () => {
    if (useIconWrapper) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)('icon', className, containerClassNames) || undefined
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: (0, _classnames.default)('material-icons', className, iconClassNames) || undefined
      }, name));
    }
    return /*#__PURE__*/_react.default.createElement("i", {
      className: (0, _classnames.default)('material-icons', className, iconClassNames) || undefined
    }, name);
  };
  const RenderAs = iconTextFlex ? 'div' : 'span';
  if (iconText) {
    return /*#__PURE__*/_react.default.createElement(RenderAs, {
      className: (0, _classnames.default)('icon-text', className, iconTextWrapperClassNames, 'is-align-items-center') || undefined
    }, /*#__PURE__*/_react.default.createElement(IconToRender, null), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(iconTextClassNames) || undefined
    }, iconText));
  }
  return /*#__PURE__*/_react.default.createElement(IconToRender, null);
};
Icon.propTypes = {
  className: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  containerSize: _propTypes.default.string,
  size: _propTypes.default.number,
  light: _propTypes.default.bool,
  dark: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  useIconWrapper: _propTypes.default.bool,
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text', 'black-bis', 'black-ter', 'white-bis', 'white-ter', 'grey-darker', 'grey-dark', 'grey-light', 'grey-lighter']), _propTypes.default.string]),
  iconText: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  iconTextFlex: _propTypes.default.bool
};
Icon.defaultProps = {
  className: '',
  useIconWrapper: true,
  inverted: false,
  size: 4
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Icon);
//# sourceMappingURL=Icon.js.map